import Swal from "sweetalert2";

function showError(err) {
  if (!err.accessDenied) {
    Swal.fire({
      title: "Error",
      text:
        err?.data?.message ||
        err?.data?.error?.message ||
        "Something went wrong...",
      icon: "error",
    });
  }
}

// Module-local, not state: a pending promise is not something to render from.
const inFlight = {};

export default {
  namespaced: true,
  state: {
    configs: {},
    loaded: {},
    isLoading: false,
    isSaving: false,
  },
  mutations: {
    SET_STATE: (state, obj) => {
      state[`${obj.key}`] = obj.value;
    },
    SET_CONFIG: (state, { profileType, config }) => {
      state.configs = { ...state.configs, [profileType]: config || null };
    },
    SET_LOADED: (state, { profileType, value }) => {
      state.loaded = { ...state.loaded, [profileType]: !!value };
    },
  },
  actions: {
    fetchConfig(
      { state, commit },
      { profileType, force = false, silent = true } = {}
    ) {
      if (!force && state.loaded[profileType]) {
        return Promise.resolve(state.configs[profileType] || null);
      }
      if (inFlight[profileType]) {
        return inFlight[profileType];
      }

      commit("SET_STATE", { key: "isLoading", value: true });
      const vm = this;

      inFlight[profileType] = vm.$http
        .get(`settings/profile-navigation/${profileType}`)
        .then((res) => {
          const config = (res.data && res.data.data) || null;
          commit("SET_CONFIG", { profileType, config });
          commit("SET_LOADED", { profileType, value: true });
          return config;
        })
        .catch((err) => {
          commit("SET_CONFIG", { profileType, config: null });
          if (silent) {
            if (!err || !err.accessDenied) console.error(err);
          } else {
            showError(err);
          }
          return null;
        })
        .finally(() => {
          commit("SET_STATE", { key: "isLoading", value: false });
          delete inFlight[profileType];
        });

      return inFlight[profileType];
    },

    saveConfig({ commit }, { profileType, bar, more }) {
      commit("SET_STATE", { key: "isSaving", value: true });
      const vm = this;

      return new Promise((resolve) => {
        return vm.$http
          .put(`settings/profile-navigation/${profileType}`, { bar, more })
          .then(
            (res) => {
              const config = (res.data && res.data.data) || null;
              commit("SET_CONFIG", { profileType, config });
              commit("SET_LOADED", { profileType, value: true });
              commit("SET_STATE", { key: "isSaving", value: false });
              resolve(true);
            },
            (err) => {
              commit("SET_STATE", { key: "isSaving", value: false });
              showError(err);
              resolve(false);
            }
          );
      });
    },

    resetConfig({ commit }, { profileType }) {
      commit("SET_STATE", { key: "isSaving", value: true });
      const vm = this;

      return new Promise((resolve) => {
        return vm.$http
          .delete(`settings/profile-navigation/${profileType}`)
          .then(
            (res) => {
              const config = (res.data && res.data.data) || null;
              commit("SET_CONFIG", { profileType, config });
              commit("SET_LOADED", { profileType, value: true });
              commit("SET_STATE", { key: "isSaving", value: false });
              resolve(true);
            },
            (err) => {
              commit("SET_STATE", { key: "isSaving", value: false });
              showError(err);
              resolve(false);
            }
          );
      });
    },
  },
};
